import { AppRoute } from '@app/core/routing/AppRoute';
import { AdminGroupsRoutes } from '@app/modules/admin/screens/groups/AdminGroupsRoutes';
import { AdminStationsRoutes } from '@app/modules/admin/screens/stations/AdminStationsRoutes';
import { AdminUsersRoutes } from '@app/modules/admin/screens/users/AdminUsersRoutes';
import { UserRole } from '@mi-front/core';
import { Route, Switch } from 'react-router-dom';
import { AlertsRoutes } from '../screens/alerts/AlertsRoutes';
import { AdminContentAiRoutes } from '../screens/content-ai/AdminContentAiRoutes';
import { AdminDashboardPage } from '../screens/dashboard/AdminDashboardPage';
import { AdminFragmentsRoutes } from '../screens/fragments/AdminFragmentsRoutes';
import { AdminSocialExportRoutes } from '../screens/social-export/AdminSocialExportRoutes';
import { AdminVideoAnalysisRoutes } from '../screens/video-analysis/AdminVideoAnalysisRoutes';
import { YoutubeRoutes } from '@app/modules/youtube/routing/YoutubeRoutes';

export function AdminRoutes() {
  return (
    <Route path="/admin">
      <Switch>
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/stations`}
          component={AdminStationsRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/users`}
          component={AdminUsersRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/groups`}
          component={AdminGroupsRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/alerts`}
          component={AlertsRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/social-export`}
          component={AdminSocialExportRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/youtube`}
          component={YoutubeRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/fragments`}
          component={AdminFragmentsRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/content-ai`}
          component={AdminContentAiRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin/video-analysis`}
          component={AdminVideoAnalysisRoutes}
        />
        <AppRoute
          allowedRole={UserRole.CLIENT_ADMIN}
          path={`/admin`}
          component={AdminDashboardPage}
        />
      </Switch>
    </Route>
  );
}
